/* unplugin-vue-components disabled */import { render } from "./SuperviserTask.vue?vue&type=template&id=7cff34bc&scoped=true"
import script from "./SuperviserTask.vue?vue&type=script&lang=js"
export * from "./SuperviserTask.vue?vue&type=script&lang=js"

import "./SuperviserTask.vue?vue&type=style&index=0&id=7cff34bc&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cff34bc"]])

export default __exports__